export default __webpack_public_path__ + "static/media/fiolet_4k.b50e0d66.svg";